export default __webpack_public_path__ + "b9a12ecf33da6aee9032201482988c47.png";